// @flow
import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import Navbar from "../../Layouts/Navbar";
import Header from "../../Layouts/Header";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";

export default function FavoriteVendorsList(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendors, setVendors] = React.useState([]);

    React.useEffect(() => {
        window.localStorage.removeItem("fromSearch");
        const params = {
            count : 48,
            list: 1,
            orderBy: 'id',
            orderType: 'desc',
        }

        API.getFavoriteVendors(params)
            .then((response) => {
                setVendors(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, [id]);
    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='لیست فروشنده های مورد علاقه' hasBack={true} />

            {/* Servitor */}
            <section className="container-fluid mb-5 mt-3 py-5 rtl px-0  ">

                <div className="row mx-3">
                    {
                        vendors.map (vendor => {
                            return (
                                <div className="col-6 px-3 py-1" key={vendor.id}
                                     onClick={
                                         () => {
                                             navigate(`/vendor/${vendor.id}`);
                                         }
                                     }
                                >
                                    <div className="vendor-container row p-2 ">
                                        <div className="col-12 vendor-image  ">
                                            <img src={vendor.image} alt={vendor.title} />
                                        </div>
                                        <div className="col-12 ">
                                            <div className="title py-2 pe-2">
                                                {vendor.title}
                                            </div>
                                            <div className="description pe-2 ">
                                                {vendor.brief.substring(0,45)} ...

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )} )

                    }
                </div>
            </section>

            <Navbar />
        </React.Fragment>
    );
};
